(function ($) {
    // USE STRICT
    "use strict";

    $(document).ready(function () {

        $('.fancy-select-wrapper .basic').fancySelect();

    });

})(jQuery);